import { Page } from '@/pages/AdvancedEditor/AdvancedEditor';
import { getPageProperty } from '@/pages/AdvancedEditor/hooks';
import { PolotnoStoreActivePageKeys } from '@/pages/AdvancedEditor/hooks/polotno-store';
import { getValidUrl } from '@/pages/AdvancedEditor/hooks/useGenerateScenes';
import { getAvatarPresenterFromPage } from '@/pages/AdvancedEditor/utils/getAvatarFromPage';
import { buildScript, buildTalkTtsInput } from '@/services/d-id/talks';
import { VideoType } from '@d-id/types';

export const getSceneScript = (page: Page, subtitlesActive: boolean) => {
    const presenter = getAvatarPresenterFromPage(page);
    const text = getPageProperty(page, PolotnoStoreActivePageKeys.textInput).trim();
    const selectedVoice = getPageProperty(page, PolotnoStoreActivePageKeys.ttsSelectedVoice);
    const audioData = getPageProperty(page, PolotnoStoreActivePageKeys.uploadedAudio);
    const voiceConfig = getPageProperty(page, PolotnoStoreActivePageKeys.ttsVoiceConfig);

    const rawScript = buildScript(text, selectedVoice, voiceConfig, subtitlesActive, getValidUrl(audioData?.data as string));

    if (!rawScript) {
        return null;
    }

    return buildTalkTtsInput(rawScript, presenter?.type === VideoType.TALK);
};
